import getBlockFirstChildElement from './get-block-first-child-element';

const getBlockFirstChildElementTag = (element) => {
  const blockElement = getBlockFirstChildElement(element);
  return blockElement && blockElement.nodeName.toLowerCase();
};

export default getBlockFirstChildElementTag;
